<template>
  <div id="app" :class="[isNoAbsolute? '' : 'absolute']" v-cloak>
    <keep-alive>
      <router-view
        :class="[isGlobalCss? 'global' : '' ]"
        v-if="isRouterAlive && $route.meta.keepAlive"
      ></router-view>
    </keep-alive>
    <router-view
      :class="[isGlobalCss? 'global' : '' ]"
      v-if="isRouterAlive && !$route.meta.keepAlive"
    ></router-view>
  </div>
</template>

<script>
  // import VConsole from "vconsole/dist/vconsole.min.js";
  import wx from "weixin-js-sdk";
  import api from "@/api/index";
  export default {
    name: "App",
    provide() {
      return {
        reload: this.reload,
        setGlobalCss: this.setGlobalCss,
        app: this
      };
    },
    data() {
      return {
        isRouterAlive: true,
        isGlobalCss: true,
        isNoAbsolute: false
      };
    },
    mounted() {
      // let vConsole = new VConsole();
      this.StatisticsFlow();
      console.log("ua", navigator.userAgent);
      // 统计用户在线时长
      this.$http.post(
        api.onlineTime,
        this.$ObjToFd({
          ip: localStorage.getItem("ip")
        })
      );
      // this.staticTest()
      // 创建cnzz统计js
    const script = document.createElement('script')
    script.src = 'https://s9.cnzz.com/z_stat.php?id=1279838499&web_id=1279838499'
    script.language = 'JavaScript'
    document.body.appendChild(script)
    },
    methods: {
      setGlobalCss(bool) {
        this.isGlobalCss = bool;
      },
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function() {
          this.isRouterAlive = true;
        });
      },
      shareHtml() {
        let params = {
          url: window.location.href.split("#")[0]
        };
        let url = `wx/wx_sign?url=${params.url}`;
        this.$http.get(url).then(res => {
          if (res.status === 200) {
            // let that = this
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.data.appId, // 必填，公众号的唯一标识
              timestamp: res.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
              signature: res.data.signature, // 必填，签名
              jsApiList: [
                "onMenuShareTimeline",
                "onMenuShareAppMessage",
                "onMenuShareQQ",
                "onMenuShareWeibo",
                "onMenuShareQZone"
              ] // 必填，需要使用的JS接口列表
              // jsApiList: res.data.jsApiList // 必填，需要使用的JS接口列表
            });
            // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口（即将废弃）
            wx.ready(function() {
              let options = {
                title: "深读健康",
                desc: "先看视频再问诊，明白一点！深读为你的健康提供专业服务",
                link: "https://wx.shendutv.com/",
                imgUrl: "https://wx.shendutv.com/images/638667815392809725.png"
              };
              wx.onMenuShareTimeline({
                title: options.title, // 分享标题
                link: options.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: options.imgUrl // 分享图标
              });
              // 获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）
              wx.onMenuShareAppMessage({
                title: options.title, // 分享标题
                desc: options.desc, // 分享描述
                link: options.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: options.imgUrl, // 分享图标
                success: function() {
                  // 用户点击了分享后执行的回调函数
                }
              });
              wx.onMenuShareQQ({
                title: options.title, // 分享标题
                desc: options.desc, // 分享描述
                link: options.link, // 分享链接
                imgUrl: options.imgUrl, // 分享图标
                success: function() {
                  // 用户确认分享后执行的回调函数
                },
                cancel: function() {
                  // 用户取消分享后执行的回调函数
                }
              });
              // 获取“分享到weibo”按钮点击状态及自定义分享内容接口（即将废弃）
              wx.onMenuShareWeibo({
                title: options.title, // 分享标题
                desc: options.desc, // 分享描述
                link: options.link, // 分享链接
                imgUrl: options.imgUrl, // 分享图标
                success: function() {
                  // 用户确认分享后执行的回调函数
                },
                cancel: function() {
                  // 用户取消分享后执行的回调函数
                }
              });
              // 获取“分享到QQ空间”按钮点击状态及自定义分享内容接口（即将废弃）
              wx.onMenuShareQZone({
                title: options.title, // 分享标题
                desc: options.desc, // 分享描述
                link: options.link, // 分享链接
                imgUrl: options.imgUrl, // 分享图标
                success: function() {
                  // 用户确认分享后执行的回调函数
                },
                cancel: function() {
                  // 用户取消分享后执行的回调函数
                }
              });
            });
          }
        });
      },
      // 统计流量
      StatisticsFlow() {
        // eslint-disable-next-line
        var _hmt = _hmt || [];
        (function() {
          var hm = document.createElement("script");
          hm.src = "https://hm.baidu.com/hm.js?d71fba110fd6a1074faf2e0e10638427";
          var s = document.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(hm, s);
        })();
      },
      staticTest() {
        // eslint-disable-next-line
        window._hmt = _hmt || [];
        (function() {
          var hm = document.createElement("script");
          hm.src = "https://hm.baidu.com/hm.js?566860e3cdfd5a9b8e0295b9b35d89af";
          var s = document.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(hm, s);
        })();
      }
    },
    watch: {
      '$route': {
        handler(to, from) {
          setTimeout(() => { //避免首次获取不到window._czc
            if (window._czc) {  
              let location = window.location; 
              let contentUrl = location.pathname + location.hash;  
              let refererUrl = '/';  
              // 用于发送某个URL的PV统计请求，
              window._czc.push(['_trackPageview', contentUrl, refererUrl])  
            }
          }, 300) 
        },
        immediate: true  // 首次进入页面即执行
    },
      $route(val) {
        const { isNoAbsolute } = val.meta;
        // console.log('isNoAbsolute')
        if (!isNoAbsolute) {
          this.isNoAbsolute = false;
          return;
        }
        this.isNoAbsolute = true;
      }
    }
  };
</script>

<style lang="postcss">
  #app {
    &.absolute {
      position: absolute;
    }
    height: 100%;
    width: 100%;
    background-color: #fffffd;
    /* touch-action: none; */
    /* overflow: hidden; */
    & .app-box {
      display: -webkit-box;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      padding: 10px;
      margin: -10px;
    }
  }
  [v-cloak] {
    display: none;
  }
  .el-notification {
    width: 700px;
    height: 100px;
  }
  /* 2019年9月12日16:55:09 底部弹出框出了问题 */
  .van-popup--bottom {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  .van-popup--top {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  /* 2019年9月12日16:58:14 */
  .van-toast {
    z-index: 9999999999999 !important;
    font-size: 28px !important;
    /* background:-webkit-gradient(linear, 0 0, 100% 0, from(#72bd19), to(#37bd19)); */
    border-radius: 50px;
    /* height: 60px; */
    box-shadow: 0px 0px 0px rgba(34, 122, 14, 0.5) !important;
    background-color: rgba(34, 122, 14, 0) !important;
    & div {
      display: flex;
      padding: 10px 30px !important;
      text-align: center;
      background-color: rgba(34, 122, 14, 0) !important;
      background: -webkit-gradient(
        linear,
        0 0,
        100% 0,
        from(#72bd19),
        to(#37bd19)
      );
      border-radius: 50px;
    }
    & .van-toast__text {
      font-size: 32px !important;
      line-height: 48px;
    }
  }
  .van-dialog {
    height: 350px;
    font-size: 32px;
    border-radius: 20px;
    background-color: #fffffd;
    & .van-dialog__content {
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    & .van-hairline--top {
      height: 88px;
      & .van-button {
        height: 88px;
      }
    }
  }
  .van-button__text {
    font-size: 32px;
  }
  .van-modal {
    /* z-index: 99999 !important; */
  }
</style>
<style lang="less">
  @import "vant/lib/index.css";
  @import "./assets/css/icon.css";
  @import "./assets/css/reset.less";
  @import "~muse-ui/lib/styles/theme.less";
</style>



// WEBPACK FOOTER //
// src/App.vue